import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import QuizIcon from '@mui/icons-material/Quiz'
import { routeFrontOfficeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeCommonUser'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeInsightPharmacienAndUserTeam = [
  // Le « Tableau de bord » Insight (/frontoffice/insight/home) est SUPPRIMÉ : la page
  // n'apportait rien que « Mes enquêtes » ne porte déjà — qui devient la HOME de l'espace.
  ...routeFrontOfficeCommonUser,

  {
    // FUSION « À faire » + « Terminées » : une seule entrée, la page porte le segmented
    // control (défaut : À faire s'il en reste, sinon Terminées). C'est AUSSI la cible de
    // l'action survey_pmi du registre /me/actions (route nommée MySurveys côté serveur).
    route: 'MySurveys',
    text: 'Mes enquêtes',
    t: 'routes.frontoffice.insight.mySurveys',
    icon: QuizIcon,
    href: '/frontoffice/insight/tache/list',
    home: true,
    menuHeader: true,
    position: 20,
  },
  // Vues « A faire » / « Terminees » de l'ECRAN UNIFIE « Mes enquetes », qui pilote son
  // onglet par le query param `q`. Ces routes pointaient encore vers les anciennes pages
  // /list/todo et /list/completed : les cards du dashboard (FrontendLink) envoyaient donc
  // sur un ecran legacy au lieu du bon onglet. Les anciennes pages restent accessibles en
  // direct pour les deep-links et favoris existants.
  {
    route: 'SurveyListTodo',
    text: 'Enquêtes à faire',
    t: 'routes.frontoffice.insight.surveyListTodo',
    icon: QuizIcon,
    // Valeurs de EnumStatusTask (TaskList) en litteral : importer le composant depuis les
    // routes creerait un cycle d'imports (routes -> composant -> routes).
    href: '/frontoffice/insight/tache/list',
    queryParams: { q: 'todo' },
  },
  {
    route: 'SurveyListCompleted',
    text: 'Liste des questionnaires terminées',
    t: 'routes.frontoffice.insight.surveyListCompleted',
    icon: CheckCircleIcon,
    href: '/frontoffice/insight/tache/list',
    queryParams: { q: 'completed' },
  },
  {
    route: 'SurveyStartFirst',
    text: 'Démarrer  un questionnaire',
    t: 'routes.frontoffice.insight.surveyStartFirst',
    href: '/frontoffice/insight/tache/start',
  },
  {
    route: 'SurveyStartById',
    text: 'Démarrer  un questionnaire',
    t: 'routes.frontoffice.insight.surveyStartById',
    href: '/frontoffice/insight/tache/[taskId]/start',
  },
  {
    route: 'EndOfSurvey',
    text: 'Fin enquete',
    t: 'routes.frontoffice.insight.endOfSurvey',
    href: '/frontoffice/insight/tache/[taskId]/end-survey',
  },
  {
    route: 'EndSurvey',
    text: "Fin d' un questionnaire",
    t: 'routes.frontoffice.insight.endSurvey',
    href: '/webhook/tache/finish_response_survey_success',
  },
  {
    route: 'StandByResponse',
    text: 'En attente de réponse',
    t: 'routes.frontoffice.insight.standByResponse',
    href: '/frontoffice/insight/tache/[taskId]/task_response-standy',
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDINSIGHT],
  roles: [
    CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_PHARMACIEN,
    CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_USER_TEAM,
    CONSTANTS.ROLE_DYNAMIC_ROUTE_STUDENT_USER,
  ],
}))
